import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PhotoUploadScreen() {
  const [photo, setPhoto] = useState(null);
  const [currentCup, setCurrentCup] = useState('');
  const [targetCup, setTargetCup] = useState('');
  const [lift, setLift] = useState(false);
  const [implantShape, setImplantShape] = useState('round');
  const navigate = useNavigate();

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h2>Upload a Photo & Choose Your Preferences</h2>

      <div style={{ marginBottom: '1rem' }}>
        <input type="file" accept="image/*" onChange={(e) => setPhoto(e.target.files[0])} />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label>Current Cup Size: </label>
        <select value={currentCup} onChange={(e) => setCurrentCup(e.target.value)}>
          <option value="">Select</option>
          {['AA', 'A', 'B', 'C', 'D', 'DD', 'E'].map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label>Target Cup Size: </label>
        <select value={targetCup} onChange={(e) => setTargetCup(e.target.value)}>
          <option value="">Select</option>
          {['A', 'B', 'C', 'D', 'DD', 'E', 'F'].map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label>
          <input type="checkbox" checked={lift} onChange={() => setLift(!lift)} />
          Breast Lift
        </label>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label>Implant Shape: </label>
        <select value={implantShape} onChange={(e) => setImplantShape(e.target.value)}>
          <option value="round">Round</option>
          <option value="teardrop">Teardrop</option>
        </select>
      </div>

      <button
        onClick={() =>
          navigate('/preview', {
            state: {
              currentCup,
              targetCup,
              lift,
              implantShape,
              photoURL: photo ? URL.createObjectURL(photo) : null,
            },
          })
        }
      >
        Continue to Simulation
      </button>
    </div>
  );
}